import React, { useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import Form from "~/common/components/Form";
import Input from "~/common/components/Input";
import { AppContext } from "../../../RoundRegContext";
import { useTranslation } from "react-i18next";

const InquiryShort = ({ card, idx }) => {
	const { t } = useTranslation();
	const { setListByTarget } = useContext(AppContext);

	const handleChange = (e) => {
		setListByTarget({ ...card, title: e.target.value });
	};

	return (
		<>
			<div className="c__form horiz">
				<div className="f__group export-label ">
					<div className="f__control  ">
						<input
							name="inquiryShort"
							placeholder={t(
								"pages.round.RoundReg.Inquiry.content.cardType.InquiryShort.question"
							)}
							type="text"
							className={`c__input f__item`}
							value={card.title}
							onChange={handleChange}
						/>
					</div>
				</div>
				<div className="export-input-preview">
					{t("pages.round.RoundReg.Inquiry.content.cardType.InquiryShort.shortText")}
				</div>
			</div>
		</>
	);
};

export default InquiryShort;
